import { defineStore } from 'pinia'
import { getProfileDetail, updateAccountProfileId } from './api'

export const useContentProfileStore = defineStore('contentProfile', {
  state: () => ({
    activeProfile: {
      id: '',
      name: '',
      standard_sets: [],
      subjects: [],
      image_url: ''
    },
    _storedProfilesById: {},
    fetchingActiveProfile: false,
    updatingAccountProfile: false,
    isProfileSelectorOpen: false,
  }),
  actions: {
    setIsProfileSelectorOpen(flag) {
      this.isProfileSelectorOpen = flag
    },
    setActiveProfileAndStore(profile) {
      this.activeProfile = profile
      if (!this._storedProfilesById[profile.id]) {
        this.storeProfile(profile)
      }
    },
    storeProfile(profile) {
      if (profile && profile.id) {
        this._storedProfilesById[profile.id] = profile
      }
    },
    async getProfileDetail(profileId) {
      if (this._storedProfilesById[profileId]) {
        console.info(`Returning stored profile info for ${profileId}`)
        return this._storedProfilesById[profileId]
      } else {
        let profileInfo = await getProfileDetail(profileId)
        this.storeProfile(profileInfo)
        return profileInfo
      }
    },
    async setActiveProfileById(profileId) {
      if (!profileId) return
      this.fetchingActiveProfile = true
      let profileInfo = await this.getProfileDetail(profileId)
      this.fetchingActiveProfile = false
      this.setActiveProfileAndStore(profileInfo)
      return profileInfo
    },
    async updateAccountProfileId({ userUuid, profileId }) {
      if (!profileId) return
      this.updatingAccountProfile = true
      try {
        await updateAccountProfileId({userUuid, profileId})
      } catch (err) { 
        console.error(`Could not save account with selected content profile: ${JSON.stringify(err)}`)
      }
      this.updatingAccountProfile = false
      return
    }
  },

  getters: {
    profileId(state) {
      return (state.activeProfile && state.activeProfile.id) || ''
    },
    profileImageUrl(state) {
      return (state.activeProfile && state.activeProfile.image_url) || ''
    },
    visibleStandardSets(state) {
      return (state.activeProfile && state.activeProfile.standard_sets) || []
    },
    visibleStandardSetsForSubject(state) {
      let subjects = state.activeProfile.subjects || []
      return (subject, { onlyPublished }) => {
        if (!subject) {
          return []
        }
        let subjectInfo = subjects.find(s => {
          if (onlyPublished) {
            return s.subject === subject && s.published
          }
          return s.subject === subject
        })
  
        return (subjectInfo && subjectInfo.standard_sets) || []
      }
    },
    keyStandardSetForSubject(state) {
      let subjects = state.activeProfile.subjects || []
      return subject => {
        if (!subject) {
          return ''
        }
        let subjectInfo = subjects.find(s => s.subject === subject)
  
        return (subjectInfo && subjectInfo.key_standard_set) || ''
      }
    },
    staircaseStandardSetForSubject(state) {
      let subjects = state.activeProfile.subjects || []
      return subject => {
        if (!subject) {
          return ''
        }
        let subjectInfo = subjects.find(s => s.subject === subject)
  
        return (subjectInfo && subjectInfo.staircase_standard_set) || ''
      }
    },
    dropdownStandardSetForSubject(state) {
      var subjects = state.activeProfile.subjects || []
      return subject => {
        if (!subject) {
          return ''
        }
        let subjectInfo = subjects.find(s => s.subject === subject)
  
        return (subjectInfo && subjectInfo.dropdown_standard_set) || ''
      }
    },
    publishedSubjects(state) {
      return (
        (state.activeProfile &&
          state.activeProfile.subjects &&
          state.activeProfile.subjects.filter(subject => subject.published)) ||
        []
      )
    },
    standardSetLabelForSubjectCard(state) {
      var subjects = state.activeProfile.subjects || []
      return subject => {
        if (!subject) {
          return ''
        }
        let subjectInfo = subjects.find(s => s.subject === subject)
  
        return (subjectInfo && subjectInfo.standard_set_label) || ''
      }
    }
  }
})
